import counselorsApplicationsList from "./counselorsApplicationsList";
import counselorsLoansList from "./counselorsLoansList";

export default {
  applist: counselorsApplicationsList,
  loanlist: counselorsLoansList,
};
